// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root{
    --footer-height: 85px;
}
 
.footer-start-section{
    width: 100%;
    min-height: var(--footer-height);
    background: var(--neutral-color7) 0% 0% no-repeat padding-box;
    color: var(--neutral-color1);
    display: flex;
    grid-template-columns: 1fr;
    justify-content: center;
    align-items: center;
}
.footer-start-section > .footer-col-section{
    display: flex;
    align-items: center;
    text-align: center;
    font: normal normal normal 12px/15px Lato;
    letter-spacing: 0px;
    justify-content: center;
    gap:8px;
    color: var(--neutral-color4);
}
 
/* .footer-start-section > .footer-col-section:first-child{
    grid-template-columns: 1fr 1fr;
} */
 
/* .footer-legal-links{
    color: var(--neutral-color1);
}
.footer-legal-links:hover{
    color: var(--neutral-color4);
}
.footer-col-section .footer-legal-links:first-child{
    border-right: 1px solid white;
} */
 
/* .footer-start-section > .footer-col-section:nth-child(2){
    text-align: end;
} */
.footer-start-section .footer-col-section:first-child{
    align-items: flex-start;
    /* margin-top: 28px; */
    margin-right: 10px;
}
.footer-start-section .footer-col-section:first-child img{
    width: 30px;
    height: 30px;
}
 
 
 
/* --------- Mobile Design ----------- */
@media screen and (max-width:992px) {
    :root{
        --footer-height: 180px;
    }
    /* .footer-start-section{
        grid-template-columns: 1fr;
        padding: 31px 21px;
        position: relative;
    }
    .footer-start-section > .footer-col-section:first-child{
        grid-template-columns: 1fr;
        text-align: left;
    }
    .footer-col-section .footer-legal-links:first-child{
        border-right: none;
    }
    .footer-start-section > .footer-col-section:nth-child(2){
        text-align: left;
    }
    .footer-start-section .footer-col-section:last-child{
        position: absolute;
        margin-top: 0;
        right: 21px;
        top: 31px;
    } */
 
     .footer-start-section {
   display: flex;
   justify-content: center;
   align-items: center;
   padding: 10px;
 }
 .footer-col-section {
   display: flex;
   flex-direction: row;
   justify-content: center;
   align-items: center;
   text-align: center;
   gap: 8px;
   flex-wrap: nowrap;
 }
 .footer-col-section img {
   width: 18px;
   margin-right: 6px;
 }
 .footer-col-section div {
   font-size: 11px;
   white-space: nowrap;
 }
}`, "",{"version":3,"sources":["webpack://./src/Assets/CSS/Footer.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,gCAAgC;IAChC,6DAA6D;IAC7D,4BAA4B;IAC5B,aAAa;IACb,0BAA0B;IAC1B,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,kBAAkB;IAClB,yCAAyC;IACzC,mBAAmB;IACnB,uBAAuB;IACvB,OAAO;IACP,4BAA4B;AAChC;;AAEA;;GAEG;;AAEH;;;;;;;;GAQG;;AAEH;;GAEG;AACH;IACI,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;AACtB;AACA;IACI,WAAW;IACX,YAAY;AAChB;;;;AAIA,wCAAwC;AACxC;IACI;QACI,sBAAsB;IAC1B;IACA;;;;;;;;;;;;;;;;;;;;OAoBG;;KAEF;GACF,aAAa;GACb,uBAAuB;GACvB,mBAAmB;GACnB,aAAa;CACf;CACA;GACE,aAAa;GACb,mBAAmB;GACnB,uBAAuB;GACvB,mBAAmB;GACnB,kBAAkB;GAClB,QAAQ;GACR,iBAAiB;CACnB;CACA;GACE,WAAW;GACX,iBAAiB;CACnB;CACA;GACE,eAAe;GACf,mBAAmB;CACrB;AACD","sourcesContent":[":root{\r\n    --footer-height: 85px;\r\n}\r\n \r\n.footer-start-section{\r\n    width: 100%;\r\n    min-height: var(--footer-height);\r\n    background: var(--neutral-color7) 0% 0% no-repeat padding-box;\r\n    color: var(--neutral-color1);\r\n    display: flex;\r\n    grid-template-columns: 1fr;\r\n    justify-content: center;\r\n    align-items: center;\r\n}\r\n.footer-start-section > .footer-col-section{\r\n    display: flex;\r\n    align-items: center;\r\n    text-align: center;\r\n    font: normal normal normal 12px/15px Lato;\r\n    letter-spacing: 0px;\r\n    justify-content: center;\r\n    gap:8px;\r\n    color: var(--neutral-color4);\r\n}\r\n \r\n/* .footer-start-section > .footer-col-section:first-child{\r\n    grid-template-columns: 1fr 1fr;\r\n} */\r\n \r\n/* .footer-legal-links{\r\n    color: var(--neutral-color1);\r\n}\r\n.footer-legal-links:hover{\r\n    color: var(--neutral-color4);\r\n}\r\n.footer-col-section .footer-legal-links:first-child{\r\n    border-right: 1px solid white;\r\n} */\r\n \r\n/* .footer-start-section > .footer-col-section:nth-child(2){\r\n    text-align: end;\r\n} */\r\n.footer-start-section .footer-col-section:first-child{\r\n    align-items: flex-start;\r\n    /* margin-top: 28px; */\r\n    margin-right: 10px;\r\n}\r\n.footer-start-section .footer-col-section:first-child img{\r\n    width: 30px;\r\n    height: 30px;\r\n}\r\n \r\n \r\n \r\n/* --------- Mobile Design ----------- */\r\n@media screen and (max-width:992px) {\r\n    :root{\r\n        --footer-height: 180px;\r\n    }\r\n    /* .footer-start-section{\r\n        grid-template-columns: 1fr;\r\n        padding: 31px 21px;\r\n        position: relative;\r\n    }\r\n    .footer-start-section > .footer-col-section:first-child{\r\n        grid-template-columns: 1fr;\r\n        text-align: left;\r\n    }\r\n    .footer-col-section .footer-legal-links:first-child{\r\n        border-right: none;\r\n    }\r\n    .footer-start-section > .footer-col-section:nth-child(2){\r\n        text-align: left;\r\n    }\r\n    .footer-start-section .footer-col-section:last-child{\r\n        position: absolute;\r\n        margin-top: 0;\r\n        right: 21px;\r\n        top: 31px;\r\n    } */\r\n \r\n     .footer-start-section {\r\n   display: flex;\r\n   justify-content: center;\r\n   align-items: center;\r\n   padding: 10px;\r\n }\r\n .footer-col-section {\r\n   display: flex;\r\n   flex-direction: row;\r\n   justify-content: center;\r\n   align-items: center;\r\n   text-align: center;\r\n   gap: 8px;\r\n   flex-wrap: nowrap;\r\n }\r\n .footer-col-section img {\r\n   width: 18px;\r\n   margin-right: 6px;\r\n }\r\n .footer-col-section div {\r\n   font-size: 11px;\r\n   white-space: nowrap;\r\n }\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
